import TeamFilledIcon from './TeamFilledIcon';

export default TeamFilledIcon;
